"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ActiveSection = /*#__PURE__*/function () {
  function ActiveSection(item, params) {
    _classCallCheck(this, ActiveSection);

    this.item = item;
    this.section = document.getElementById(this.item.dataset.target);
    this.progress = this.item.querySelector('.js-active-section-progress');
    this.scrollX = params.scrollX;
    this.scrollY = params.scrollY;
    this.container = params.container;

    if (this.section) {
      this.coords = this.getCoords();
      this.listen();
    }
  }

  _createClass(ActiveSection, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      var listener = this.container ? this.container : window;
      listener.addEventListener('scroll', function (event) {
        _this.coords = _this.getCoords();
        var scroll = _this.container ? listener.scrollTop : listener.scrollY + window.innerHeight / 2;

        if (scroll >= _this.coords.top && scroll < _this.coords.bottom) {
          _this.item.classList.add('is-active');

          if (_this.scrollX) {
            _this.scrollX.scroll({
              left: _this.item.offsetLeft
            });
          }

          if (_this.scrollY) {
            _this.scrollY.scroll({
              top: _this.item.offsetTop - _this.scrollY.offsetTop
            });
          }
        } else {
          _this.item.classList.remove('is-active');
        }

        _this.setProgression(scroll);
      });
    }
  }, {
    key: "getCoords",
    value: function getCoords() {
      var height = this.section.offsetHeight;
      var top = this.section.offsetTop;
      var offset = this.container ? this.container.offsetTop : 0;
      return {
        height: height,
        top: top - offset,
        bottom: top + height - offset
      };
    }
  }, {
    key: "setProgression",
    value: function setProgression(scroll) {
      if (this.progress) {
        var percent = (scroll - this.coords.top) / this.coords.height * 100;
        this.progress.style.width = percent < 100 ? "".concat(percent, "%") : '0';
      }
    }
  }]);

  return ActiveSection;
}();

document.addEventListener('DOMContentLoaded', function () {
  var sections = _toConsumableArray(document.getElementsByClassName('js-active-section'));

  if (sections.length) {
    sections.forEach(function (section) {
      return new ActiveSection(section, {
        container: document.getElementById(section.dataset.container),
        scrollX: document.getElementById(section.dataset.scrollX),
        scrollY: document.getElementById(section.dataset.scrollY)
      });
    });
  }
});